import { render, staticRenderFns } from "./QuickLinksCard.vue?vue&type=template&id=95d82990&scoped=true"
import script from "./QuickLinksCard.vue?vue&type=script&lang=js"
export * from "./QuickLinksCard.vue?vue&type=script&lang=js"
import style0 from "./QuickLinksCard.vue?vue&type=style&index=0&id=95d82990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d82990",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog,VSpacer})
